export const configKey: any = {
  // url develop
  // apiUrl: 'http://luxura-dev-admin.innovixcommerce.com/', //dev database
  // apiUrl: 'https://erp.luxuratrade.com/', //uat database
  apiUrl: ' http://shop-demo.innovixdigital.com/', //shop demo database
  // apiUrl: 'http://luxura-uat-admin.innovixcommerce.com/',
  // apiUrl: 'http://luxura-uat-clone-admin.innovixcommerce.com/', //uat clone
  // url production
  facebookAppId: '2755458538036395',
  googleclientId:
    '1017036782317-ei6bhobvnuq7alvtf98844ipp07m7fva.apps.googleusercontent.com',
  googleMapKey: 'AIzaSyAC4zZkHZYUto-qvsVig7XvTAdz9qb2wNM',
  // googleMapKey: 'AIzaSyC5i0mt34lAKRc2J59PlC-M9T6TPyk817g', // mind

  onesignalAppIdKey: 'ed5b95cc-9902-4943-8316-f18016315d49',
  onesignalRestApiKey: 'ZDM1ZGYxZWYtZWMxMy00NGUyLWFlYzMtNzNlOWU3NDQ5YzQz',

  webClientId:
    '747520609251-ru039pff1gfhln347vk8fsd9hlls51cm.apps.googleusercontent.com',

  db: 'acs_server_testing',
}
